import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { EngineeringLeftMenuList } from "../utils/constants";
import { RenderNavItem } from "../components/RenderNavItem";

const Engineering_Home = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
        </div>
      </section>
      {/* End Slider */}

      <section className="section inner-pad1">
        <div className="container ">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu ">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {EngineeringLeftMenuList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title2">
                    <h3 className="fontSizeClass">
                      {t(
                        "Manholes without Cover? Damaged Roads? Uprooted Trees?"
                      )}
                    </h3>
                  </div>
                  <section id="faq" className="faq advertisement civil">
                    <p className="fontSizeClass">
                      {t(
                        "As a citizen of Kolkata, you often face such civic problems. And you are unaware of what to do or where to go, to tackle them. Your awareness will not only save you from further trouble but will also help us to serve you better. Take a quick look at these problems and their solutions provided by the Engineering Department of KMC"
                      )}
                      .
                    </p>
                    <h2 className="btm-pad">{t("Do's")}</h2>
                    <div className="">
                      <div className="row gy-4">
                        <div className="col-lg-12 d-flex flex-column justify-content-center align-items-stretch  order-2 order-lg-1 no-margin">
                          <div id="accordion">
                            <div className="card">
                              <div className="card-header" id="heading1">
                                <button
                                  className="btn btn-link fontSizeClass  m-2"
                                  data-toggle="collapse"
                                  data-target="#collapse1"
                                  aria-expanded="true"
                                  aria-controls="collapse1"
                                >
                                  {t(
                                    "Stolen covers of manholes/gully-pits cover"
                                  )}
                                </button>
                              </div>
                              <div
                                id="collapse1"
                                className="collapse show"
                                data-parent="#accordion"
                              >
                                <div className="card-body m-3 fontSizeClass">
                                  {t(
                                    "Immediately inform the KMC Control Room/Borough Office/local Ward Office"
                                  )}
                                  .
                                </div>
                              </div>
                            </div>
                            <div className="card">
                              <div className="card-header" id="heading2">
                                <button
                                  className="btn btn-link fontSizeClass  m-2"
                                  data-toggle="collapse"
                                  data-target="#collapse2"
                                  aria-expanded="true"
                                  aria-controls="collapse2"
                                >
                                  {t("Removal of House Drainage Chockage")}
                                </button>
                              </div>
                              <div
                                id="collapse2"
                                className="collapse"
                                data-parent="#accordion"
                              >
                                <div className="card-body m-3 fontSizeClass">
                                  {t(
                                    "Contact the Ward Office/Borough Office. Deposit Rs. 185 in favour of KMC ."
                                  )}
                                  
                                </div>
                              </div>
                            </div>
                            <div className="card">
                              <div className="card-header" id="heading3">
                                <button
                                  className="btn btn-link fontSizeClass  m-2"
                                  data-toggle="collapse"
                                  data-target="#collapse3"
                                  aria-expanded="true"
                                  aria-controls="collapse3"
                                >
                                  {t(
                                    "Removal of Chockage of sewer on KMC thoroughfare ."
                                  )}
                                  
                                </button>
                              </div>
                              <div
                                id="collapse3"
                                className="collapse"
                                data-parent="#accordion"
                              >
                                <div className="card-body m-3 fontSizeClass">
                                  {t(
                                    "Contact the local Ward Office/Borough Office/Control Room."
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="card">
                              <div className="card-header" id="heading4">
                                <button
                                  className="btn btn-link fontSizeClass  m-2"
                                  data-toggle="collapse"
                                  data-target="#collapse4"
                                  aria-expanded="true"
                                  aria-controls="collapse4"
                                >
                                  {t("Drainage connection for New House")}
                                </button>
                              </div>
                              <div
                                id="collapse4"
                                className="collapse"
                                data-parent="#accordion">
                                <div className="card-body m-3 fontSizeClass">
                                  <ul className="kmc-function-list">
                                    <li>
                                      {t(
                                        "Apply through enlisted plumber of KMC. List of such plumber will be available at the Borough Office"
                                      )}
                                      .
                                    </li>
                                    <li>
                                      {t(
                                        "Select a plumber from your own choice. The plumber would assist you for getting the sanction to the house drainage plan of your premises and he will execute the internal drainage system and effect the house drainage connection finally to municipal drain/sewer under supervision of Engineering Dept"
                                      )}
                                      .
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>                                                                                                                                      
                            
                            <div className="card">
                              <div className="card-header" id="heading6">
                                <button
                                  className="btn btn-link fontSizeClass  m-2"
                                  data-toggle="collapse"
                                  data-target="#collapse6"
                                  aria-expanded="true"
                                  aria-controls="collapse6"
                                >
                                  {t(
                                    "Documents required for new house drainage connection"
                                  )}
                                </button>
                              </div>
                              <div
                                id="collapse6"
                                className="collapse"
                                data-parent="#accordion"
                              >
                                <div className="card-body m-3 fontSizeClass">
                                  <ul className="kmc-function-list">
                                    <li>
                                      {t(
                                        "Plumber Neyogpatra/Letter of Engagement"
                                      )}
                                      .
                                    </li>
                                    <li>
                                      {t(
                                        "Copy of Building Sanction Plan alongwith the original copy for verification purpose ."
                                      )}
                                      
                                    </li>
                                    <li>
                                      {t(
                                        "Lay out of the proposed internal house drainage plan showing the proposed connection with the KMC sewer ."
                                      )}
                                      
                                    </li>
                                    <li>
                                      {t(
                                        "Photo copy of the enlistment Certificate of Plumber"
                                      )}
                                    </li>
                                    <li> {t("Current Tax Bill")} </li>
                                    <li>
                                      {t(
                                        "NOC from Assessment & Collection Deptt. and Law Deptt"
                                      )}
                                      .
                                    </li>
                                    <li>
                                      {t(
                                        "Occupancy Certificate during effecting House Drainage Connection ."
                                      )}
                                      
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                            <div className="card">
                              <div className="card-header" id="heading7">
                                <button
                                  className="btn btn-link fontSizeClass  m-2"
                                  data-toggle="collapse"
                                  data-target="#collapse7"
                                  aria-expanded="true"
                                  aria-controls="collapse7"
                                >
                                  {t("Carriageway sanction plan")}
                                </button>
                              </div>
                              <div
                                id="collapse7"
                                className="collapse"
                                data-parent="#accordion"
                              >
                                <div className="card-body m-3 fontSizeClass">
                                  <ul className="kmc-function-list">
                                    <li>
                                      {t(
                                        "In case of new building sanction of carriageway is compulsory"
                                      )}
                                      .
                                    </li>
                                    <li>
                                      {t(
                                        "Engage KMC enlisted LBA/LBS/Plumber/Enlisted P.I. Contractor for getting sanction of carriageway plan"
                                      )}
                                      .
                                    </li>
                                    <li> {t("Deposit the required fees")}. </li>
                                    <li>
                                      {t(
                                        "Submit the Neyogpatra/Letter of Engagement of LBA/LBS/Plumber/Enlisted P.I. Contractor for getting the sanction of carriageway plan"
                                      )}
                                    </li>
                                    <li>
                                      {t(
                                        "Copy of building sanction plan alongwith the original copy for verification purpose"
                                      )}
                                      .
                                    </li>
                                    <li>
                                      {t(
                                        "Drawing of the proposed carriageway plan"
                                      )}
                                      .
                                    </li>
                                    <li>
                                      {t(
                                        "Photo copy of the enlisted plumber/LBA/LBS/Enlisted P.I. Contractor ."
                                      )}
                                      
                                    </li>
                                    <li> {t("Current Tax Bill")}. </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                            <div className="card">
                              <div className="card-header" id="heading8">
                                <button
                                  className="btn btn-link fontSizeClass  m-2"
                                  data-toggle="collapse"
                                  data-target="#collapse8"
                                  aria-expanded="true"
                                  aria-controls="collapse8"
                                >
                                  {t("Repairing of pot-holes on roads")}
                                </button>
                              </div>
                              <div
                                id="collapse8"
                                className="collapse"
                                data-parent="#accordion"
                              >
                                <div className="card-body m-3 fontSizeClass">
                                  {t(
                                    "Inform the local Ward Office/Borough Office/KMC Control Room."
                                  )}
                                  
                                </div>
                              </div>
                            </div>
                            <div className="card">
                              <div className="card-header" id="heading9">
                                <button
                                  className="btn btn-link fontSizeClass  m-2"
                                  data-toggle="collapse"
                                  data-target="#collapse9"
                                  aria-expanded="true"
                                  aria-controls="collapse9"
                                >
                                  {t("Removal of uprooted trees")}
                                </button>
                              </div>
                              <div
                                id="collapse9"
                                className="collapse"
                                data-parent="#accordion"
                              >
                                <div className="card-body m-3 fontSizeClass">
                                  {t(
                                    "Inform the KMC Control Room."
                                  )}
                                  
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <br />
                    <h2 className="fontSizeClass">{t("Don'ts")}</h2>
                    <ul className="kmc-function-list pl-3">
                      <li>
                        {t("Do not allow contaminated water on the roads")}
                      </li>
                      <li>
                        {t(
                          "Do not occupy any road/footpath to construct any structure/garden"
                        )}
                      </li>
                      <li>
                        {t(
                          "Do not urinate in any open area other than the public urinals"
                        )}
                      </li>
                      <li>
                        {t(
                          "Do not prune/cut off any tree/sapling in front of your premise without KMC's permission"
                        )}
                      </li>
                      <li>
                        {t(
                          "Do not throw wastes/garbage on KMC roads. For this contact the Borough Office"
                        )}
                      </li>
                      <li>
                        {t("Do not let your pet dog excrete on the roads")}.
                      </li>
                      <p className="fontSizeClass">
                        {t(
                          "Help us to make Kolkata, a clean, green city. As a dutiful citizen, your responsibilities, awareness and civic knowledge are necessary. The above directions will definitely show you the right way ."
                        )}
                        
                      </p>
                    </ul>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Engineering_Home;
